import { z } from "zod";

import { branded } from "@/lib/helpers/branded-helper.ts";

export enum ESiteInstallationFlow {
  PROVISION = "PROVISION",
  SALE = "SALE",
}

export enum ESiteInstallationCommunicationType {
  PAPER = "PAPER",
  ELECTRONIC = "ELECTRONIC",
}

export enum ESiteInstallationStatus {
  ONGOING = "ONGOING",
  DONE = "DONE",
}

export enum EPaperFlowSignatureRequestState {
  TO_PROCESS = "TO_PROCESS",
  SENT = "SENT",
  ERROR = "ERROR",
}

export enum ESubscriberSignatureStatus {
  PENDING = "PENDING",
  SENT = "SENT",
  SIGNED = "SIGNED",
  ERROR = "ERROR",
  CANCELED = "CANCELED",
}

export const siteInstallationFlowSchema = z.nativeEnum(ESiteInstallationFlow);
export const siteInstallationCommunicationTypeSchema = z.nativeEnum(ESiteInstallationCommunicationType);
export const siteInstallationStatusSchema = z.nativeEnum(ESiteInstallationStatus);
export const paperFlowSignatureRequestStateSchema = z.nativeEnum(EPaperFlowSignatureRequestState);
export const subscriberSignatureStatusSchema = z.nativeEnum(ESubscriberSignatureStatus);

export const signatureDetailsDtoSchema = z.object({
  flow: siteInstallationFlowSchema.nullable(),
  communicationType: siteInstallationCommunicationTypeSchema.nullable(),
  status: siteInstallationStatusSchema.nullable(),
  paperFlowSignatureState: paperFlowSignatureRequestStateSchema.nullable(),
  subscriberSignatureStatus: subscriberSignatureStatusSchema.nullable(),
  signatureRequestDate: z.coerce.date().nullable(),
  signatureDate: z.coerce.date().nullable(),
  installationSheetUploadDate: z.coerce.date().nullable(),
  signatureRequestId: branded.escSubscriberSignatureId.nullable(),
  isRegenerable: z.boolean().nullable(),
});

export type TSignatureDetailsDto = z.infer<typeof signatureDetailsDtoSchema>;
